<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" viewBox="0 0 25 25" fill="none">
    <path
      d="M12.5 20C12.925 20 13.2812 19.8562 13.5687 19.5687C13.8562 19.2812 14 18.925 14 18.5C14 18.075 13.8562 17.7187 13.5687 17.4312C13.2812 17.1437 12.925 17 12.5 17C12.075 17 11.7188 17.1437 11.4313 17.4312C11.1438 17.7187 11 18.075 11 18.5C11 18.925 11.1438 19.2812 11.4313 19.5687C11.7188 19.8562 12.075 20 12.5 20ZM11 14H14V5H11V14Z"
      fill="currentColor"
    />
  </svg>
</template>
